import {
  STRING_getInstance7xungxdjbzv as STRING_getInstance,
  INT_getInstance32g3l1d0jirwg as INT_getInstance,
  BOOLEAN_getInstancewc2j8mltq0p1 as BOOLEAN_getInstance,
  DOUBLE_getInstance26ldxisjb14a2 as DOUBLE_getInstance,
  LONG_getInstance2g4gwhhf21sqr as LONG_getInstance,
  BYTE_getInstance19ddfopm3uuty as BYTE_getInstance,
  SHORT_getInstancext99ki650964 as SHORT_getInstance,
  FLOAT_getInstance2yidggfln26xa as FLOAT_getInstance,
  CHAR_getInstance38268mv2tvqra as CHAR_getInstance,
} from '../descriptors/SerialKinds.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Char19o2r8palgjof as Char } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
} from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../descriptors/SerialDescriptor.mjs';
import {
  Unit_instance3kz1zqli6gr1r as Unit_instance,
  Unitkvevlwgzwiuc as Unit,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from './ObjectSerializer.mjs';
import { initBuiltins3cd82qqvse108 as initBuiltins } from './Platform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_BUILTIN_SERIALIZERS() {
  _init_properties_Primitives_kt__k0eto4();
  return BUILTIN_SERIALIZERS;
}
var BUILTIN_SERIALIZERS;
var StringSerializerClass;
function StringSerializer() {
  if (StringSerializerClass === VOID) {
    class $ {
      constructor() {
        StringSerializer_instance = this;
        this.n26_1 = new (PrimitiveSerialDescriptor())('kotlin.String', STRING_getInstance());
      }
      b1n() {
        return this.n26_1;
      }
      o26(encoder, value) {
        return encoder.x1s(value);
      }
      c1n(encoder, value) {
        return this.o26(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      d1n(decoder) {
        return decoder.n1r();
      }
    }
    initMetadataForObject($, 'StringSerializer', VOID, VOID, [KSerializer()]);
    StringSerializerClass = $;
  }
  return StringSerializerClass;
}
var StringSerializer_instance;
function StringSerializer_getInstance() {
  if (StringSerializer_instance === VOID)
    new (StringSerializer())();
  return StringSerializer_instance;
}
var IntSerializerClass;
function IntSerializer() {
  if (IntSerializerClass === VOID) {
    class $ {
      constructor() {
        IntSerializer_instance = this;
        this.p26_1 = new (PrimitiveSerialDescriptor())('kotlin.Int', INT_getInstance());
      }
      b1n() {
        return this.p26_1;
      }
      q26(encoder, value) {
        return encoder.s1s(value);
      }
      c1n(encoder, value) {
        return this.q26(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      d1n(decoder) {
        return decoder.i1r();
      }
    }
    initMetadataForObject($, 'IntSerializer', VOID, VOID, [KSerializer()]);
    IntSerializerClass = $;
  }
  return IntSerializerClass;
}
var IntSerializer_instance;
function IntSerializer_getInstance() {
  if (IntSerializer_instance === VOID)
    new (IntSerializer())();
  return IntSerializer_instance;
}
var BooleanSerializerClass;
function BooleanSerializer() {
  if (BooleanSerializerClass === VOID) {
    class $ {
      constructor() {
        BooleanSerializer_instance = this;
        this.r26_1 = new (PrimitiveSerialDescriptor())('kotlin.Boolean', BOOLEAN_getInstance());
      }
      b1n() {
        return this.r26_1;
      }
      s26(encoder, value) {
        return encoder.p1s(value);
      }
      c1n(encoder, value) {
        return this.s26(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      d1n(decoder) {
        return decoder.f1r();
      }
    }
    initMetadataForObject($, 'BooleanSerializer', VOID, VOID, [KSerializer()]);
    BooleanSerializerClass = $;
  }
  return BooleanSerializerClass;
}
var BooleanSerializer_instance;
function BooleanSerializer_getInstance() {
  if (BooleanSerializer_instance === VOID)
    new (BooleanSerializer())();
  return BooleanSerializer_instance;
}
var DoubleSerializerClass;
function DoubleSerializer() {
  if (DoubleSerializerClass === VOID) {
    class $ {
      constructor() {
        DoubleSerializer_instance = this;
        this.t26_1 = new (PrimitiveSerialDescriptor())('kotlin.Double', DOUBLE_getInstance());
      }
      b1n() {
        return this.t26_1;
      }
      u26(encoder, value) {
        return encoder.v1s(value);
      }
      c1n(encoder, value) {
        return this.u26(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      d1n(decoder) {
        return decoder.l1r();
      }
    }
    initMetadataForObject($, 'DoubleSerializer', VOID, VOID, [KSerializer()]);
    DoubleSerializerClass = $;
  }
  return DoubleSerializerClass;
}
var DoubleSerializer_instance;
function DoubleSerializer_getInstance() {
  if (DoubleSerializer_instance === VOID)
    new (DoubleSerializer())();
  return DoubleSerializer_instance;
}
var LongSerializerClass;
function LongSerializer() {
  if (LongSerializerClass === VOID) {
    class $ {
      constructor() {
        LongSerializer_instance = this;
        this.v26_1 = new (PrimitiveSerialDescriptor())('kotlin.Long', LONG_getInstance());
      }
      b1n() {
        return this.v26_1;
      }
      w26(encoder, value) {
        return encoder.t1s(value);
      }
      c1n(encoder, value) {
        return this.w26(encoder, (!(value == null) ? typeof value === 'bigint' : false) ? value : THROW_CCE());
      }
      d1n(decoder) {
        return decoder.j1r();
      }
    }
    initMetadataForObject($, 'LongSerializer', VOID, VOID, [KSerializer()]);
    LongSerializerClass = $;
  }
  return LongSerializerClass;
}
var LongSerializer_instance;
function LongSerializer_getInstance() {
  if (LongSerializer_instance === VOID)
    new (LongSerializer())();
  return LongSerializer_instance;
}
function builtinSerializerOrNull(_this__u8e3s4) {
  _init_properties_Primitives_kt__k0eto4();
  var tmp = get_BUILTIN_SERIALIZERS().v4(_this__u8e3s4);
  return (tmp == null ? true : isInterface(tmp, KSerializer())) ? tmp : THROW_CCE();
}
var ByteSerializerClass;
function ByteSerializer() {
  if (ByteSerializerClass === VOID) {
    class $ {
      constructor() {
        ByteSerializer_instance = this;
        this.x26_1 = new (PrimitiveSerialDescriptor())('kotlin.Byte', BYTE_getInstance());
      }
      b1n() {
        return this.x26_1;
      }
      y26(encoder, value) {
        return encoder.q1s(value);
      }
      c1n(encoder, value) {
        return this.y26(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      d1n(decoder) {
        return decoder.g1r();
      }
    }
    initMetadataForObject($, 'ByteSerializer', VOID, VOID, [KSerializer()]);
    ByteSerializerClass = $;
  }
  return ByteSerializerClass;
}
var ByteSerializer_instance;
function ByteSerializer_getInstance() {
  if (ByteSerializer_instance === VOID)
    new (ByteSerializer())();
  return ByteSerializer_instance;
}
var ShortSerializerClass;
function ShortSerializer() {
  if (ShortSerializerClass === VOID) {
    class $ {
      constructor() {
        ShortSerializer_instance = this;
        this.z26_1 = new (PrimitiveSerialDescriptor())('kotlin.Short', SHORT_getInstance());
      }
      b1n() {
        return this.z26_1;
      }
      a27(encoder, value) {
        return encoder.r1s(value);
      }
      c1n(encoder, value) {
        return this.a27(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      d1n(decoder) {
        return decoder.h1r();
      }
    }
    initMetadataForObject($, 'ShortSerializer', VOID, VOID, [KSerializer()]);
    ShortSerializerClass = $;
  }
  return ShortSerializerClass;
}
var ShortSerializer_instance;
function ShortSerializer_getInstance() {
  if (ShortSerializer_instance === VOID)
    new (ShortSerializer())();
  return ShortSerializer_instance;
}
var FloatSerializerClass;
function FloatSerializer() {
  if (FloatSerializerClass === VOID) {
    class $ {
      constructor() {
        FloatSerializer_instance = this;
        this.b27_1 = new (PrimitiveSerialDescriptor())('kotlin.Float', FLOAT_getInstance());
      }
      b1n() {
        return this.b27_1;
      }
      c27(encoder, value) {
        return encoder.u1s(value);
      }
      c1n(encoder, value) {
        return this.c27(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
      }
      d1n(decoder) {
        return decoder.k1r();
      }
    }
    initMetadataForObject($, 'FloatSerializer', VOID, VOID, [KSerializer()]);
    FloatSerializerClass = $;
  }
  return FloatSerializerClass;
}
var FloatSerializer_instance;
function FloatSerializer_getInstance() {
  if (FloatSerializer_instance === VOID)
    new (FloatSerializer())();
  return FloatSerializer_instance;
}
var CharSerializerClass;
function CharSerializer() {
  if (CharSerializerClass === VOID) {
    class $ {
      constructor() {
        CharSerializer_instance = this;
        this.d27_1 = new (PrimitiveSerialDescriptor())('kotlin.Char', CHAR_getInstance());
      }
      b1n() {
        return this.d27_1;
      }
      e27(encoder, value) {
        return encoder.w1s(value);
      }
      c1n(encoder, value) {
        return this.e27(encoder, value instanceof Char() ? value.f4_1 : THROW_CCE());
      }
      f27(decoder) {
        return decoder.m1r();
      }
      d1n(decoder) {
        return new (Char())(this.f27(decoder));
      }
    }
    initMetadataForObject($, 'CharSerializer', VOID, VOID, [KSerializer()]);
    CharSerializerClass = $;
  }
  return CharSerializerClass;
}
var CharSerializer_instance;
function CharSerializer_getInstance() {
  if (CharSerializer_instance === VOID)
    new (CharSerializer())();
  return CharSerializer_instance;
}
function checkNameIsNotAPrimitive(serialName) {
  _init_properties_Primitives_kt__k0eto4();
  var values = get_BUILTIN_SERIALIZERS().x4();
  var _iterator__ex2g4s = values.p1();
  while (_iterator__ex2g4s.q1()) {
    var primitive = _iterator__ex2g4s.r1();
    var primitiveName = primitive.b1n().e1o();
    if (serialName === primitiveName) {
      throw IllegalArgumentException().o2(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).j1() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
    }
  }
}
function PrimitiveDescriptorSafe(serialName, kind) {
  _init_properties_Primitives_kt__k0eto4();
  checkNameIsNotAPrimitive(serialName);
  return new (PrimitiveSerialDescriptor())(serialName, kind);
}
function error($this) {
  throw IllegalStateException().o('Primitive descriptor ' + $this.g27_1 + ' does not have elements');
}
var PrimitiveSerialDescriptorClass;
function PrimitiveSerialDescriptor() {
  if (PrimitiveSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, kind) {
        this.g27_1 = serialName;
        this.h27_1 = kind;
      }
      e1o() {
        return this.g27_1;
      }
      x1p() {
        return this.h27_1;
      }
      z1p() {
        return 0;
      }
      b1q(index) {
        error(this);
      }
      c1q(name) {
        error(this);
      }
      f1q(index) {
        error(this);
      }
      e1q(index) {
        error(this);
      }
      d1q(index) {
        error(this);
      }
      toString() {
        return 'PrimitiveDescriptor(' + this.g27_1 + ')';
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PrimitiveSerialDescriptor()))
          return false;
        if (this.g27_1 === other.g27_1 && equals(this.h27_1, other.h27_1))
          return true;
        return false;
      }
      hashCode() {
        return getStringHashCode(this.g27_1) + imul(31, this.h27_1.hashCode()) | 0;
      }
    }
    protoOf($).q1p = get_isNullable;
    protoOf($).y1p = get_isInline;
    protoOf($).a1q = get_annotations;
    initMetadataForClass($, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    PrimitiveSerialDescriptorClass = $;
  }
  return PrimitiveSerialDescriptorClass;
}
var UnitSerializerClass;
function UnitSerializer() {
  if (UnitSerializerClass === VOID) {
    class $ {
      constructor() {
        UnitSerializer_instance = this;
        this.i27_1 = new (ObjectSerializer())('kotlin.Unit', Unit_instance);
      }
      b1n() {
        return this.i27_1.b1n();
      }
      j27(encoder, value) {
        this.i27_1.t1n(encoder, Unit_instance);
      }
      c1n(encoder, value) {
        return this.j27(encoder, value instanceof Unit() ? value : THROW_CCE());
      }
      k27(decoder) {
        this.i27_1.d1n(decoder);
      }
      d1n(decoder) {
        this.k27(decoder);
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'UnitSerializer', VOID, VOID, [KSerializer()]);
    UnitSerializerClass = $;
  }
  return UnitSerializerClass;
}
var UnitSerializer_instance;
function UnitSerializer_getInstance() {
  if (UnitSerializer_instance === VOID)
    new (UnitSerializer())();
  return UnitSerializer_instance;
}
var properties_initialized_Primitives_kt_6dpii6;
function _init_properties_Primitives_kt__k0eto4() {
  if (!properties_initialized_Primitives_kt_6dpii6) {
    properties_initialized_Primitives_kt_6dpii6 = true;
    BUILTIN_SERIALIZERS = initBuiltins();
  }
}
//region block: exports
export {
  BooleanSerializer_getInstance as BooleanSerializer_getInstance22aja3hu17sxf,
  ByteSerializer_getInstance as ByteSerializer_getInstance20v1505to7w0y,
  CharSerializer_getInstance as CharSerializer_getInstancehi0q1kl0h8cw,
  DoubleSerializer_getInstance as DoubleSerializer_getInstance1tuvibnyg07o1,
  FloatSerializer_getInstance as FloatSerializer_getInstance1c6yoefuaocts,
  IntSerializer_getInstance as IntSerializer_getInstance3jyhns9ue706g,
  LongSerializer_getInstance as LongSerializer_getInstancepwtz4tlewrfw,
  ShortSerializer_getInstance as ShortSerializer_getInstance1sui2olw3dzs8,
  StringSerializer_getInstance as StringSerializer_getInstance1p9zda6r6kb23,
  UnitSerializer_getInstance as UnitSerializer_getInstance13j6tqdl8rnmw,
  PrimitiveDescriptorSafe as PrimitiveDescriptorSafe1r3pht5v1oaqu,
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptorkwnwsc78b2on,
  builtinSerializerOrNull as builtinSerializerOrNull180kp99qvlpex,
  checkNameIsNotAPrimitive as checkNameIsNotAPrimitive28vmhppr4nskt,
};
//endregion

//# sourceMappingURL=Primitives.mjs.map
